module.exports = __webpack_public_path__ + "img/Cote d’Ivoire.85da4bf4.gif";